import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useDownloadTableModal } from '../context/DownloadTableModalContext';

const DownloadTableModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useDownloadTableModal();

  const buttonDisabled = !data.pdfFormat && !data.excelFormat;

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleDownloadTable}
          disabled={buttonDisabled}
        >
          {t('DownloadListing')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default DownloadTableModalFooter;
